
import AddessForm from '@/pages/account/components/AddessForm.vue';
import { CollapseTransition } from 'element-ui';
export default {
  name: 'CardAddress',
  props: {
    address: {
      type: Object,
      required: true,
    },
    secondary: {
      type: Boolean,
      default: false,
    },
    editButton: {
      type: Boolean,
      default: true,
    },
    selectButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      edit: false,
    };
  },
  methods: {
    selectAddress() {
      this.$emit('onSelect', this.address);
    },
  },
  components: {
    AddessForm,
    CollapseTransition,
  },
};
